import { CSSProperties } from 'react';

import clsx from 'clsx';

import { SIZE } from '@/enums';

interface ToolbarProps {
  items: {
    handleItemClick: () => void;
    isSelected: boolean;
    icon: (props: { className?: string }) => React.ReactElement | null;
    styles?: CSSProperties;
  }[];
  size?: SIZE;
  isDisabled?: boolean;
}

export const Toolbar = ({ items, size = SIZE.SMALL, isDisabled = false }: ToolbarProps) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-center gap-1 rounded-lg border border-blue-powder p-0.5',
        {
          ['h-8']: size === SIZE.SMALL,
          ['h-9']: size === SIZE.MEDIUM,
          ['h-12']: size === SIZE.LARGE
        }
      )}>
      {items.map((item, index) => (
        <div
          key={index}
          onClick={item.handleItemClick}
          className={clsx(
            'flex size-7 cursor-pointer items-center justify-center rounded-md transition-all duration-300',
            { ['pointer-events-none select-none opacity-50']: isDisabled },
            item.isSelected ? 'bg-blue-powder text-black' : 'bg-transparent text-slate-gray'
          )}
          style={item.styles}>
          {item.icon({})}
        </div>
      ))}
    </div>
  );
};
